import type { FunctionComponent } from 'react';
import { useState } from 'react';

import type { BlocklistConfidence, BlocklistMatch } from '@ballerine/business-analysis-schemas';

import { BlocklistMatchList } from './BlocklistMatchList';

const ROW_CAP = 10;

const CONFIDENCE_RANK: Record<BlocklistConfidence, number> = {
  high: 0,
  medium: 1,
};

type BlocklistWidgetProps = {
  matches: BlocklistMatch[];
};

export const BlocklistWidget: FunctionComponent<BlocklistWidgetProps> = ({ matches }) => {
  const [showAll, setShowAll] = useState(false);

  if (matches.length === 0) {
    return null;
  }

  const sortedMatches = [...matches].sort(
    (a, b) => CONFIDENCE_RANK[a.confidence] - CONFIDENCE_RANK[b.confidence],
  );

  const hasOverflow = sortedMatches.length > ROW_CAP;
  const visibleMatches = showAll ? sortedMatches : sortedMatches.slice(0, ROW_CAP);
  const hiddenCount = sortedMatches.length - ROW_CAP;

  return (
    <div className="flex flex-col gap-2">
      <BlocklistMatchList matches={visibleMatches} />

      {hasOverflow && (
        <button
          type="button"
          onClick={() => setShowAll(previous => !previous)}
          className="self-start text-sm font-medium text-blue-600 hover:text-blue-700"
        >
          {showAll ? 'View less' : `+${hiddenCount} more`}
        </button>
      )}
    </div>
  );
};
